import Request from './Request'
import constants from "../constants/constant";

const PosService = {
	cached_pos: null,
	async getPos() {
		if( !PosService.cached_pos ) {
			const _pods = await Request.get('/api/pos')	
			PosService.cached_pos = _pods
		}
		return PosService.cached_pos
	},
	downloadPos(clientId) {
		window.open(`${constants.BACKEND_DOMAIN}/clients/${clientId}/download-pos?_access_token=${localStorage.getItem('access_token')}`, '_blank')
		// Request.get(`/api/clients/${clientId}/download-pos`, {responseType: "blob"}).then(response => {
		// 	console.log(response)
		// 	const url = window.URL.createObjectURL(new Blob([response.data]));
		// 	const link = document.createElement("a");
		// 	link.href = url;
		// 	link.setAttribute(
		// 		"download",
		// 		`${this.props.file.name}.${this.props.file.mime}`
		// 	);
		// 	document.body.appendChild(link);
		// 	link.click();
		//
		// 	// Clean up and remove the link
		// 	link.parentNode.removeChild(link);
		// })
	},
}

export default PosService